import App from './App.svelte';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import styles from './app.css';

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyBS-A3VDZPQtyb6mbygDTwl-iVUVN7ogIc",
    authDomain: "socialdeduction-b37dd.firebaseapp.com",
    databaseURL: "https://socialdeduction-b37dd.firebaseio.com",
    projectId: "socialdeduction-b37dd",
    storageBucket: "socialdeduction-b37dd.appspot.com",
    messagingSenderId: "979833082452",
    appId: "1:979833082452:web:90c0a99b4e148538"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  window.db = firebase.firestore();
  window.functions = firebase.functions();

const app = new App({
	target: document.body,
	props: {
	}
});

export default app;
